import React from 'react';
import { AlertTriangle, Mail } from 'lucide-react';

import { useLanguage } from '../contexts/LanguageContext';

export const BetaBanner: React.FC = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = React.useState(true);

  React.useEffect(() => {
    const dismissed = localStorage.getItem('msd_beta_banner_dismissed');
    if (dismissed) setIsVisible(false);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('msd_beta_banner_dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="relative w-full z-[100] bg-amber-100 border-b border-amber-200 text-amber-900 px-3 py-1.5 sm:py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex-1 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-center sm:text-left text-xs sm:text-sm font-medium">
          <div className="flex items-center gap-1.5 sm:gap-2">
            <AlertTriangle size={14} className="text-amber-600 shrink-0 sm:w-4 sm:h-4" />
            <span>
              <strong className="font-bold">{t.betaBannerPrefix}</strong> {t.betaBannerText}
            </span>
          </div>
          <div className="hidden sm:block text-amber-300">|</div>
          <div className="flex items-center gap-2">
            <span>{t.betaBannerFeedback}</span>
            <a
              href="mailto:triyodesk@gmail.com"
              className="flex items-center gap-1.5 bg-white/50 hover:bg-white px-2 py-0.5 rounded-lg transition-colors text-amber-800 hover:text-amber-950 border border-amber-200"
            >
              <Mail size={12} className="sm:w-3.5 sm:h-3.5" />
              triyodesk@gmail.com
            </a>
          </div>
        </div>

        <button
          onClick={handleDismiss}
          className="ml-2 p-1 hover:bg-amber-200/50 rounded-full transition-colors text-amber-800"
          aria-label="Dismiss banner"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </div>
  );
};
